import { IconButton } from '@wix/design-system';
import { Dismiss } from '@wix/wix-ui-icons-common';
import React, { FC } from 'react';

import { LayoutTwoThirds } from '../../../chatbot/icons';
import { dismissCopilot } from '../../../messageChannel/postNewMessages';
import { renderModel } from '../../../util/renderModel';
import css from './styles.scss';

const isCopilot = renderModel.isCopilot();

export const CancelButton: FC<{}> = () => {
  if (isCopilot) {
    return (
      <IconButton size="small" skin="dark" priority="secondary" onClick={dismissCopilot}>
        <LayoutTwoThirds />
      </IconButton>
    );
  }

  return <Dismiss onClick={dismissCopilot} className={css.cancelButton} />;
};
